import { searchParam } from '@luminovo/design-system';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod/v4';

import NegotiationQuoteRequestEmailPreviewPage from '@/areas/quote-requests/NegotiationQuoteRequests/QuoteRequestEmailPreviewPage';
import { quoteRequestsBelongTo } from '@/domain/quoteRequest/quoteRequestHandler';
import type { PageStaticData } from '@/shared/routing';

// The email names the negotiation, and the page shows the quote requests in the negotiation's sidebar. Quote requests
// of another negotiation, which only a hand-edited URL brings, render the not-found page rather than send their
// suppliers an email with this negotiation's name.
export const Route = createFileRoute(
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/preview-email',
)({
    staticData: { access: { permissions: ['view:sourcing'] }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: z.object({ quoteRequestIds: searchParam.list('required') }),
    loaderDeps: ({ search }) => ({ quoteRequestIds: search.quoteRequestIds }),
    loader: async ({ context: { queryClient }, params: { negotiationId }, deps: { quoteRequestIds } }) => {
        if (
            !(await quoteRequestsBelongTo(queryClient, quoteRequestIds, { type: 'NegotiationV2', id: negotiationId }))
        ) {
            throw notFound();
        }
    },
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const quoteRequestIds = Route.useSearch({ select: (search) => search.quoteRequestIds });
    return <NegotiationQuoteRequestEmailPreviewPage {...pathParams} quoteRequestIds={quoteRequestIds} />;
}
